import { DEFAULT_API_DATETIME_LOCAL_MOMENT_FORMAT, formatLocalDateTime } from "utils/dateTime";

export { getInitials } from "utils/getInitials";

export function formatFeedTimestamp(dateStr?: string): string {
  return formatLocalDateTime(dateStr, { format: DEFAULT_API_DATETIME_LOCAL_MOMENT_FORMAT });
}

const EMBEDDED_ACTIVITY_DATETIME_SUFFIX =
  /\s+on\s+\d{1,2}\/\d{1,2}\/\d{4}(?:\s+\d{1,2}:\d{2}(?::\d{2})?)?\s*$/i;

export function stripActivityMessageEmbeddedDateTime(message: string): string {
  const trimmed = message.trim();
  if (!trimmed) return trimmed;
  const stripped = trimmed
    .replace(EMBEDDED_ACTIVITY_DATETIME_SUFFIX, "")
    .replace(/\s{2,}/g, " ")
    .trim();
  return stripped || trimmed;
}
